import { combineReducers } from 'redux';
import * as Types from './dashboard.constants';

function makeRequestReducer(actionType, defaultData = [], state = {}) {
  const initialState = {
    data: defaultData,
    error: false,
    loading: false,
    errorMsg: '',
    ...state,
  };
  return (state = initialState, action) => {
    switch (action?.type) {
      case `${actionType}_REQUEST`:
        return {
          ...state,
          loading: true,
          error: false,
        };
      case `${actionType}_SUCCESS`:
        return {
          ...state,
          loading: false,
          error: false,
          data: action?.payload?.data,
          errorMsg: ''
        };
      case `${actionType}_FAILED`:
        return {
          ...state,
          loading: false,
          error: true,
          data: defaultData,
          errorMsg: action?.payload?.error
        };
      case `${actionType}_RESET`:
        return state;
      default:
        return state;
    }
  };
}

export default combineReducers({
  planDistribution: makeRequestReducer(Types.GET_PLAN_DISTRIBUTION,{}),
  statisticsData: makeRequestReducer(Types.GET_STATISTCS,{}),
  todaysBirthdayList: makeRequestReducer(Types.GET_TODAYS_BIRTHDAY_LIST),
  usersStats: makeRequestReducer(Types.GET_USERS_STATS, {}),
  visitorsStats: makeRequestReducer(Types.GET_VISITORS_STATS, {})
});
